import React from 'react';

import { ContactInfo, Heading } from '../../../components';



const Contact = () => {
  return (
    <section className='contact'>
        <Heading title={'contact us'} />   
        <ContactInfo />  
    </section>
  )
}

export default Contact;